/* eslint-disable no-undef */
// utility funciton coz parent for DC and Db are to be retrieved differently
export const getParent = obj => {
	return obj.dashboardContainerId || obj.parentId || null;
};

// helper funciton which using given array of DC and Db into single map for parent and childarray
export function populateParentChild(flatArrayOfDcAndDb) {
	const pCMap = {}; // parentChildMap :: object with key as parentId and value as array of objects of all childs
	const cPMap = {}; // childPropMap :: object with key as id and value as object with props (defined in state)
	flatArrayOfDcAndDb.map(obj => {
		// this object can be DC or Db
		const parent = obj.dashboardContainerId || obj.parentId || null;
		if (Object.prototype.hasOwnProperty.call(pCMap, parent)) pCMap[parent].push(obj);
		else pCMap[parent] = [obj];
		cPMap[obj.id] = {
			name: obj.name,
			sortOrder: obj.sortOrder,
			parentId: parent
		};
	});
	return [pCMap, cPMap];
}

// check if id is a DC-id or not
export function isDashboardContainer(id, dcArr) {
	let result = false;
	if (Array.isArray(dcArr)) {
		dcArr.map(dc => {
			result = result || dc.id === id;
		});
	}
	return result;
}

export const setHelpDeskPrefill = (userDetails, orgDetails, url) => {
	const cfNotes = orgDetails.hasOwnProperty("query")
		? `Organization: ${orgDetails.orgId} \nQuery: ${orgDetails.query} \nUrl: ${url}`
		: `Organization: ${orgDetails.orgId} \nDashboard: ${orgDetails.dashboardName} \nUrl: ${url}`;
	FreshworksWidget("clear", "ticketForm");
	FreshworksWidget("prefill", "ticketForm", {
		priority: 1,
		name: userDetails.name || "",
		email: userDetails.email || "",
		custom_fields: {
			cfNotes
		}
	});
	FreshworksWidget("hide", "ticketForm", ["priority", "type", "name", "email", "custom_fields.cfNotes"]);
};
